<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Data</b-card-title>
      </b-card-header>

      <b-card-body>
        <b-row class="mb-1">
          <b-col
            cols="8"
            offset-md="2"
          >
            <h4>Filter</h4>
            <b-form
              class="needs-validation"
              @submit.prevent="submitFilter"
            >
              <b-row>
                <b-col cols="6">
                  <b-form-group
                    label="Tahun"
                    label-for="tahunFilter"
                  >
                    <b-form-select
                      id="tahunFilter"
                      v-model="tahunFilter"
                      :options="dataTahun"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Wilayah"
                    label-for="wilayahFilter"
                  >
                    <b-form-select
                      id="wilayahFilter"
                      v-model="wilayahFilter"
                      :options="dataWilayah"
                      :disabled="!$can('Filter', 'beritaAcara')"
                      @change="changeWilayah"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    label="PD/UPD"
                    label-for="pdUpdFilter"
                  >
                    <v-select
                      id="kolok"
                      v-model="pdUpdFilterValue"
                      label="text"
                      :options="dataPdUpd"
                      :disabled="
                        !$can('Filter', 'beritaAcara') &&
                          !$can('Filter-PdUpd', 'beritaAcara')
                      "
                      @search="searchPdUpd"
                      @input="inputPdUpd"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-col
                cols="12"
                align="right"
                class="pr-0"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  size="sm"
                  type="submit"
                >
                  Lihat
                </b-button>
              </b-col>
            </b-form>
          </b-col>

          <b-col
            cols="12"
            class="mt-2"
          >
            <!-- table -->
            <b-row>
              <b-col
                cols="6"
                align="right"
              >
                <b-button
                  v-b-tooltip.hover
                  size="large"
                  class="mb-2 cols-6"
                  variant="success"
                  :disabled="!pdUpdFilterValue.value || !isDownload"
                  :title="
                    isDownload
                      ? 'Download Berita Acara'
                      : 'Pelaksanaan Inventarisasi Harus Selesai Semua'
                  "
                  @click="downloadFile"
                >
                  <b-col cols="12">
                    <b-icon
                      icon="download"
                      style="width: 100px; height: 100px"
                    />
                  </b-col>
                  <b-col cols="12">
                    Download Berita Acara
                  </b-col>
                </b-button>
              </b-col>
              <b-col
                v-if="$can('Upload', 'beritaAcara')"
                cols="6"
              >
                <b-button
                  v-b-tooltip.hover
                  v-b-modal.modal-upload
                  size="large"
                  class="mb-2 cols-6"
                  variant="info"
                  :title="
                    isDownload
                      ? 'Upload Berita Acara'
                      : 'Pelaksanaan Inventarisasi Harus Selesai Semua'
                  "
                  :disabled="!pdUpdFilterValue.value || !isDownload"
                >
                  <b-col cols="12">
                    <b-icon
                      icon="upload"
                      style="width: 100px; height: 100px"
                    />
                  </b-col>
                  <b-col cols="12">
                    Upload Berita Acara
                  </b-col>
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <div
          id="showPdf"
          class="mb-2"
        />
      </b-card-body>
    </b-card>

    <b-card no-body>
      <b-card-header>
        <b-card-title>File</b-card-title>
      </b-card-header>

      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            class="mt-2"
          >
            <!-- table -->
            <vue-good-table
              :columns="columns"
              :rows="rows"
              :total-rows="totalRecords"
              :is-loading.sync="isLoading"
              mode="remote"
              @on-sort-change="onSortChange"
            >
              <template
                slot="table-row"
                slot-scope="props"
              >
                <!-- Column: file -->
                <span
                  v-if="props.column.field === 'file'"
                  class="align-self-center"
                >
                  <b-button
                    v-b-tooltip.hover
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-primary"
                    class="btn-icon rounded-circle"
                    title="Berita Acara"
                    @click="downloadFile2(props.row.document)"
                  >
                    <feather-icon icon="FileTextIcon" />
                  </b-button>
                </span>
                <!-- Column: updated_date -->
                <span
                  v-if="props.column.field === 'updated_date'"
                  class="align-self-center"
                >
                  {{ momentFormat(props.row.updated_date) }}
                </span>

                <!-- Column: Common -->
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!-- modal login-->
    <b-modal
      id="modal-upload"
      ref="modal-upload"
      cancel-variant="outline-secondary"
      centered
      title="Upload Berita Acara"
    >
      <b-form-group
        label="Berita Acara"
        label-for="filePdf"
        class="mt-2"
      >
        <b-form-file
          id="filePdf"
          v-model="filePdf"
          accept="application/pdf"
        />
      </b-form-group>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            size="sm"
            class="float-right"
            :disabled="!filePdf"
            @click="submitForm"
          >
            <div v-if="isLoadingUpload">
              <b-spinner small />
              <span class="sr-only">Loading...</span>
            </div>
            <div v-else>
              Simpan
            </div>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButton,
  BFormGroup,
  BFormSelect,
  BForm,
  BIcon,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import moment from 'moment'
import vSelect from 'vue-select'
import { generateYears, startYear } from '@/libs/helper'
import master from '@/composables/master'
import beritaAcara from '@/composables/beritaAcara'
import dashboard from '@/composables/dashboard'
import apiCetakDaftarBmd from '@/composables/cetakDaftarBmd'

export default {
  setup(props, context) {
    // global variable
    const g = context.root
    const { $route } = g

    const year = moment().format('YYYY')

    // variable untuk table
    const rows = ref([])
    const searchTerm = ref('')
    const start = ref(1)
    const row = ref(10)
    const totalRecords = ref(0)
    const sortColumn = ref('')
    const order = ref('')
    const isLoading = ref(false)
    const isLoadingUpload = ref(false)
    const isDownload = ref(false)

    const tahunFilter = ref($route.query.tahun || year)
    const pdUpdFilter = ref($route.query['pd-upd'] || '')
    const pdUpdFilterValue = ref({
      text: pdUpdFilter.value || '-- Pilih Salah Satu --',
      value: pdUpdFilter.value || '',
    })
    const wilayahFilter = ref($route.query.wilayah || '')
    const kibFilter = ref($route.query.kib || 'C')
    const ukuranFilter = ref($route.query.ukuran || 1)

    const totalBmdBelumTercatat = ref(0)
    const jumlahBmdKolok = ref(0)
    const jumlahSelesaiSensus = ref(0)

    const filePdf = ref(null)

    const cookiesJenisAkun = ref(g.$cookies.get('jenisAkun'))

    if (cookiesJenisAkun.value == 'D' || cookiesJenisAkun.value == 'F') {
      const cookiesNalok = ref(g.$cookies.get('nalok'))
      const cookiesKolok = ref(g.$cookies.get('kolok'))
      const cookiesWilayah = ref(g.$cookies.get('wilayah'))
      pdUpdFilterValue.value = {
        text: `${cookiesKolok.value}::${cookiesNalok.value}`,
        value: cookiesKolok.value,
      }
      pdUpdFilter.value = cookiesKolok.value
      wilayahFilter.value = cookiesWilayah.value
    } else if (cookiesJenisAkun.value == 'pelaksana-suban') {
      wilayahFilter.value = parseInt(g.$cookies.get('wilayah'), 10)
    }

    const dataTahun = ref(generateYears(startYear, year))
    const dataWilayah = ref([{ text: '-- Semua --', value: '' }])
    const dataPdUpd = ref([{ text: '-- Pilih Salah Satu --', value: '' }])
    const dataProvinsi = ref([])
    const dataKecamatan = ref([])
    const dataKelurahan = ref([])
    const dataKib = ref([{ text: '-- Semua --', value: '' }])
    const dataUkuran = ref([
      { text: '6.5 x 10', value: 1 },
      { text: '15 x 10', value: 2 },
    ])

    const barcodes = ref([])

    // fungsi ambil data untuk table
    const datatable = async () => {
      isLoading.value = true

      const params = {
        filter_upd: pdUpdFilter.value,
      }
      const response = await beritaAcara.getData(g, params)
      const { code, data, totalData } = response

      if (code == 200) {
        rows.value = data.map(item => ({
          ...item,
          kolok: `${item.kolok}${item.nalok ? ` :: ${item.nalok}` : ''}`,
        }))
        totalRecords.value = totalData
      } else {
        rows.value = []
        totalRecords.value = 0
      }

      isLoading.value = false
    }

    const dataSummary = async () => {
      isDownload.value = false
      const params = {
        filter_ukpd: pdUpdFilter.value,
        length: 10,
        start: 0,
      }
      const dashboardSummary = await dashboard.getDashboardSummary(g, params)
      const { code, list } = dashboardSummary

      if (code == 200) {
        if (list.length > 0) {
          jumlahBmdKolok.value = list[0].jumlahBmdKolok
          jumlahSelesaiSensus.value = list[0].jumlahSelesaiSensus
          if (parseInt(list[0].jumlahBmdKolok, 10) + totalBmdBelumTercatat.value == list[0].jumlahSelesaiSensus) {
            isDownload.value = true
          }
        }
      }
    }

    const submitFilter = () => {
      const url = `?wilayah=${wilayahFilter.value}&pd-upd=${pdUpdFilterValue.value.value}`
      window.history.pushState('', '', url)
      datatable()
      dataSummary()
    }

    datatable()

    dataSummary()

    const downloadFile = async () => {
      window.open(
        `https://jakaset.jakarta.go.id/${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/cetak-ba?filter_upd=${pdUpdFilter.value}`,
        '_blank',
      )
    }

    const getWilayah = async () => {
      const resWilayah = await master.getWilayah(g)
      resWilayah.unshift({ text: '-- Semua --', value: '' })

      dataWilayah.value = resWilayah
    }

    getWilayah()

    const submitForm = async () => {
      isLoadingUpload.value = true
      const fd = new FormData()
      // mapping data
      fd.append('username', g.$cookies.get('username'))
      fd.append('upd', pdUpdFilterValue.value.value)
      fd.append('document', filePdf.value)
      await beritaAcara.upload(g, fd)
      context.refs['modal-upload'].hide()
      datatable()

      isLoadingUpload.value = false
    }

    const handleSearch = () => {
      start.value = 1
      datatable()
    }

    const handlePageChange = () => {
      start.value = 1
      datatable()
    }

    const handleChangePage = page => {
      start.value = (page - 1) * row.value + 1
      datatable()
    }

    const onSortChange = params => {
      sortColumn.value = params[0].field
      order.value = params[0].type
      datatable()
    }

    const getPdUpd = async (searchPdUpd = '') => {
      const params = {
        tahun: tahunFilter.value,
        cari: searchPdUpd,
        wilayah: wilayahFilter.value,
      }
      const resPdUpd = await master.getPdUpd(g, params)
      resPdUpd.unshift({ text: '-- Pilih Salah Satu --', value: '' })
      dataPdUpd.value = resPdUpd
    }

    getPdUpd()

    const changeWilayah = () => {
      if (wilayahFilter.value) {
        pdUpdFilter.value = ''
        pdUpdFilterValue.value = { text: '-- Pilih Salah Satu --', value: '' }
      }
      getPdUpd()
    }

    const searchPdUpd = async search => {
      getPdUpd(search)
    }

    const inputPdUpd = async () => {
      if (pdUpdFilterValue.value) pdUpdFilter.value = pdUpdFilterValue.value.value

      const params = {
        filter_kib: kibFilter.value,
        filter_tahun: tahunFilter.value,
        filter_upd: pdUpdFilter.value,
        kode_wilayah: wilayahFilter.value,
        filter_status: 12,
        length: 1,
        start: 0,
        cari: '',
        list: 'unfound',
      }
      const resBmd = await apiCetakDaftarBmd.getBmd(g, params)
      const { totalList } = resBmd
      totalBmdBelumTercatat.value = totalList

      if (parseInt(jumlahBmdKolok.value, 10) + totalBmdBelumTercatat.value == parseInt(jumlahSelesaiSensus.value, 10) && parseInt(jumlahSelesaiSensus.value, 10) > 0) {
        isDownload.value = true
      }
    }

    const momentFormat = tanggal => {
      const tempTanggal = moment(tanggal).format('DD-MM-YYYY HH:mm:ss')
      return tempTanggal == 'Invalid date' ? '' : tempTanggal
    }

    const downloadFile2 = file => {
      window.open(file)
    }

    return {
      rows,
      searchTerm,
      start,
      row,
      totalRecords,
      sortColumn,
      order,
      isLoading,
      isLoadingUpload,
      isDownload,
      tahunFilter,
      pdUpdFilter,
      barcodes,
      kibFilter,
      wilayahFilter,
      pdUpdFilterValue,
      ukuranFilter,
      filePdf,
      dataTahun,
      dataWilayah,
      dataPdUpd,
      dataProvinsi,
      dataKecamatan,
      dataKelurahan,
      dataKib,
      dataUkuran,
      datatable,
      handleSearch,
      handlePageChange,
      handleChangePage,
      onSortChange,
      downloadFile,
      changeWilayah,
      searchPdUpd,
      inputPdUpd,
      submitForm,
      submitFilter,
      momentFormat,
      downloadFile2,
    }
  },
  components: {
    VueGoodTable,
    vSelect,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BFormGroup,
    BFormSelect,
    BForm,
    BIcon,
  },
  directives: {
    Ripple,
  },
  props: {
    page: { type: String, default: null },
  },
  data() {
    return {
      columns: [
        {
          label: 'Nama Lokasi',
          field: 'kolok',
        },
        {
          label: 'Tanggal',
          field: 'updated_date',
        },
        {
          label: 'File',
          field: 'file',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
.pdfobject-container {
  height: 80rem;
  border: 1rem solid rgba(0, 0, 0, 0.1);
}
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
